// extracted by mini-css-extract-plugin
module.exports = {"windIndicator":"WindIndicator_windIndicator__8jLjK"};